module.exports = "<div class=\"align-right\">\r\n  <button mat-raised-button color=\"accent\" \r\n    id=\"import-button\"\r\n    (click)=\"importGame()\">Import Existing Game</button>\r\n  <button mat-raised-button color=\"accent\" \r\n    id=\"export-button\"\r\n    (click)=\"exportGame()\" [disabled]=\"!gameHasAnyScenes() || !gameHasStartScene()\">Export Game</button>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Repos/seeya/src/app/generator/import-export-game/import-export-game.component.html
// module id = ../../../../../src/app/generator/import-export-game/import-export-game.component.html
// module chunks = main